/**
 * Two-to-three letter monogram standing in for logos a payload doesn't carry —
 * the slot picker cards' default until the search indexes carry logo paths.
 */
export const entityMonogram = (name: string): string => name
  .split(/\s+/)
  .filter(word => /^\p{L}/u.test(word) && !['of', 'the', 'and'].includes(word.toLowerCase()))
  .slice(0, 3)
  .map(word => [...word][0]!.toLocaleUpperCase())
  .join('');
